import { createI18n } from 'vue-i18n'

import { DEFAULT_LOCALE, LOCALES, Locale } from '@/enums/locale'

import en from './locales/en'
import sl from './locales/sl'

export type AvailableLocales = 'sl' | 'en'

/** Whether a value is one of the console's languages. */
export const isLocale = (value: unknown): value is Locale => LOCALES.includes(value as Locale)

/*
 * How many of a thing there are. Vue I18n's built-in rule knows one and other; Slovenian has
 * four forms (1 dobavnica, 2 dobavnici, 3 dobavnice, 5 dobavnic) — CLDR's rule, the index clamped
 * to the forms a message offers.
 */
const slovenian = (choice: number, choices: number): number => {
    const pick     = (index: number): number => Math.min(index, choices - 1)
    const hundreds = Math.abs(choice) % 100

    if (hundreds === 1)                   return pick(0)
    if (hundreds === 2)                   return pick(1)
    if (hundreds === 3 || hundreds === 4) return pick(2)

    return pick(3)
}

const stored = localStorage.getItem('locale')

/*
 * Slovenian first; English is the fallback. Both files are checked against one schema
 * (`MessageSchema` in `sl.ts`; `en.ts` is `satisfies MessageSchema`), so a key missing from
 * either fails the type-check. The language chosen before signing in is remembered per browser
 * under `locale`; after signing in the person's own (`Me.locale`) takes over (`stores/app.ts`).
 */
const i18n = createI18n({
    legacy:           false,
    globalInjection:  true,
    locale:           isLocale(stored) ? stored : DEFAULT_LOCALE,
    fallbackLocale:   'en',
    messages:         { sl, en },
    availableLocales: ['sl', 'en'],
    pluralRules:      { sl: slovenian },
})

export default i18n
